import React from 'react';
import './../App.css';
import bitmojiImage from './../lib/images/bitmojiSelfie.png';
import {useTeam} from "../contexts/TeamContext";

function PlayerDisplay({id, name, number, bitmoji, goals, assists, mom, apps, showBanner, editedTheme}) {
    const {team} = useTeam();
  return (
    <div className={`d-flex ${showBanner ? 'banner' : ''}`}>
      <div className="hex-container">
          <div className="hex" style={editedTheme ? {backgroundColor: editedTheme.theme.secondaryColor} : {backgroundColor: team.theme.secondaryColor}}>
              <div className="hex inner" style={editedTheme ? {backgroundColor: editedTheme.theme.primaryColor} : {backgroundColor: team.theme.primaryColor}}>
                  <img src={bitmoji} alt="Player" className="player-image"/>
              </div>
          </div>
          <div className="player-info" style={editedTheme ? {color: editedTheme.theme.textColor} : {color: team.theme.textColor}}>
              <h4 className="player-name">{name}</h4>
              <h6 className="player-number">{number}</h6>
          </div>
      </div>
      {showBanner ? 
        <div className="d-flex w-100 justify-content-center flex-column align-items-center">
          <h6> Apps: {apps}</h6>
          <h6> Goals: {goals}</h6>
          <h6> Assists: {assists} </h6>
          <h6> Mom: {mom}</h6>
        </div>
        :
        <></>
      }
      
    </div>
  )
}

export default PlayerDisplay